<template>
  <nav>
    <ul class="nav-list">
      <li class="logo">
        <a href="/">
          <img
            :src="require('images/logo/logo.png')"
            :alt="t('layouts.header.logo_banner_alt')"
          />
        </a>
      </li>
      <li class="btn-group">
        <ul class="list">
          <li class="login-button">
            <a class="btn" href="/users/sign_in">
              {{ t('layouts.header.login') }}
            </a>
          </li>

          <li class="register-button">
            <a class="btn" href="/recruiter_applications/new">
              {{ t('layouts.header.register') }}
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </nav>
</template>

<script>
import Vue from 'vue'

import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-sugar.css'
Vue.use(VueToast)

import { isEmpty } from 'lodash'

import I18n from 'i18n/i18n'
import 'i18n/views/layouts/en'
import 'i18n/views/layouts/th'
import { i18n } from 'mixins/i18n'
window.I18n = I18n

const ViewProps = window._application.props

export default {
  mixins: [i18n],

  data() {
    return {
      currentUser: ViewProps.currentUser,
      flash: ViewProps.flash,
    }
  },

  mounted: function () {
    if (!isEmpty(this.flash)) {
      this.$toast.open({
        message: this.flash[0].message,
        type: this.flash[0].key,
        duration: 5000,
        dismissible: true,
        position: 'top-right',
      })
    }
  },
}
</script>

<style lang="scss" scoped>
@import 'stylesheets/global';

nav {
  .nav-list {
    align-items: center;
    background: transparent;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 1.5rem 2rem;

    @include sp {
      padding: 1.5rem 1rem;
    }

    .logo {
      img {
        width: 200px;

        @include sp {
          width: 120px;
        }
      }
    }

    .btn {
      line-height: 1.5;

      @include sp {
        font-size: 12px;
        padding: 10px 10px;
      }
    }

    .btn-group {
      .list {
        align-items: center;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
        line-height: 0;
        padding: 0;

        @include sp {
          line-height: 0;
          padding-left: 0;
        }

        li {
          padding: 0 1rem;

          @include sp {
            padding: 0;
          }

          &:first-child {
            @include sp {
              padding-right: 1rem;
            }
          }

          .btn {
            width: 120px;

            @include sp {
              width: auto;
            }
          }

          &.login-button {
            .btn {
              @include button($is-outline: true);
              @extend .btn;

              @include sp {
                font-size: 0.8em;
                padding-left: 1.5rem;
                padding-right: 1.5rem;
              }
            }
          }

          &.register-button {
            .btn {
              @include button;
              @extend .btn;

              @include sp {
                font-size: 0.8em;
              }
            }
          }
        }
      }
    }
  }
}
</style>
